import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

const HeaderBox = styled(Box)(() => ({
    padding:'3rem 1.5rem',
    background:'#FAFAFA',
    margin:'0 10%',
    display: 'flex',
    flexDirection: 'column',
    gap:'1.5rem',
}))

export default HeaderBox
